import React, { useState, useEffect, useRef, forwardRef } from "react";
import { primaryButtonTheme, secondaryButtonTheme, fontBold, fontMedium, fontRegular, textColorTheme, errorMsgStyle, hideContent, dispContent, smallButtonTheme } from '../../utils/AppStyle';
import { getFileDeleteIcon, getDropDownIconPath, getFileErrorIcon, getFileSuccessIcon, getFileWarningIcon, getProcessingDesc, getUploadFileIconPath, getUploadIconPath, getUploadMoreIcon, getBankLogo, loaderStyleCircle, maxPdfSize, minPdfSize } from '../../Config';
import { processUploading, statusCodeNoFilePassword, destinationPdfUpload, pdfSupportError, pdfChooseError, pdfSizeMaxError, pdfSizeMinError, selectBankHint, statusCodeInvalidPassword, inputHintPasswordUnlock, btnSubmit, btnCancel, btnYes, btnNo, statusCodeUserCancelled, stmtSubmitError, maxAllowedFilesError, stmtSubmitNoFileError, stmtCancelError, btnFinish } from '../../utils/Strings';
import { withRouter } from "react-router";
import { useHistory } from "react-router-dom";
import { deleteUiStmt, getInstitutionList, statusCheck, uploadUiStmt } from "../../utils/NetworkUtil";
import { PopUp } from "../../utils/PopUp";
import { storageRef } from "../../utils/firebase";
import FileBase64 from "../../utils/FileBase64";
import { getSearchIconPath } from "../../Config";
import { isNullOrEmpty } from "../../utils/AppUtil";
import { FaEyeSlash } from "react-icons/fa";
import { FaEye } from "react-icons/fa";
import { SmallLoader } from "../../utils/SmallLoader";
import 'react-tippy/dist/tippy.css';
import {
    Tooltip,
} from 'react-tippy';
import InputFile from "../../utils/InputFile";
import { default as ReactSelect } from "react-select";
import { ref, uploadBytesResumable, uploadString } from "firebase/storage";

const PdfUpload = ({ setShowCancel }) => {
    let history = useHistory();

    let states = {
        file_selected: 1,
        file_error: 2,
        file_deleted: 3,
        firebase_upload_processing: 4,
        firebase_upload_error: 5,
        stmt_submit_processing: 6,
        stmt_password_required: 7,
        stmt_password_processing: 8,
        stmt_password_error: 9,
        stmt_error: 10,
        stmt_processed: 11,
        stmt_delete_processing: 12,
        stmt_delete_error: 13,
        stmt_deleted: 14
    }

    const [showLoader, setShowLoader] = useState(false)
    const [isSubmitError, setIsSubmitError] = useState(false)
    const [submitErrMsg, setSubmitErrMsg] = useState("")
    const [showViewFiles, setShowViewFiles] = useState(sessionStorage.getItem("show_view_files"));
    const [selectedStatements, setSelectedStatements] = useState([]);
    //const [processedStatements, setProcessedStatements] = useState([])
    const [showCancelPopup, setShowCancelPopup] = useState(false)
    const [showConfirmPopup, setShowConfirmPopup] = useState(false)

    const [institutionId, setInstitutionId] = useState(sessionStorage.getItem('institution_id'));
    const [selectedBankId, setSelectedBankId] = useState([]);
    const [institutionIdGiven, setInstitutionIdGiven] = useState(sessionStorage.getItem('institution_id_given'));
    const [bankName, setBankName] = useState(sessionStorage.getItem('bank_name'));
    const [bankList, setBankList] = useState([]);
    const [bankLabelList, setBankLabelList] = useState([]);
    const [bankCode, setBankCode] = useState("");
    const [multiAccountSupport, setMultiAccountSupport] = useState((!isNullOrEmpty(localStorage.getItem("multi_account_support_required"))) ? localStorage.getItem("multi_account_support_required") : "0");
    const [multiSelectionEnabled, setMultiSelectionEnabled] = useState((!isNullOrEmpty(localStorage.getItem("multi_selection_enabled"))) ? localStorage.getItem("multi_selection_enabled") : "0");
    const [compressedSelectionEnabled, setCompressedSelectionEnabled] = useState((!isNullOrEmpty(localStorage.getItem("compressed_selection_enabled"))) ? localStorage.getItem("compressed_selection_enabled") : "0");
    const [bankSelectionEnabled, setBankSelectionEnabled] = useState((!isNullOrEmpty(localStorage.getItem("bank_selection_enabled"))) ? localStorage.getItem("bank_selection_enabled") : "1");
    const [maxAllowedFiles, setMaxAllowedFiles] = useState(localStorage.getItem("max_allowed_files"));

    //const [submitMultiple, setSubmitMultiple] = useState(false);


    let txnId = sessionStorage.getItem('txn_id');
    let startMonth = sessionStorage.getItem('start_month');
    let endMonth = sessionStorage.getItem('end_month');

    //const selectRef = useRef(null);

    // useEffect(() => {
    //     if (selectRef.current) {
    //         selectRef.current.focus();
    //     }
    // }, [selectedBankId]);


    useEffect(() => {
        setShowCancel("true");

        if (!isNullOrEmpty(localStorage.getItem("statement_list"))) {
            setSelectedStatements(JSON.parse(localStorage.getItem("statement_list")));
        }

        const institutionListCb = (response) => {
            let bankData = [];
            var bankLabels = [];
            let resData = response.data.data;
            for (let i = 0; i < resData.length; i++) {
                bankData.push({
                    "id": resData[i].id,
                    "name": resData[i].name,
                    "username_text": resData[i].username_text,
                    "display_name": resData[i].display_name,
                    "msg_text": resData[i].msg_text,
                    "is_pdf_applicable": resData[i].is_pdf_applicable,
                    "code": resData[i].code
                });
                bankLabels.push({ value: resData[i].id, label: resData[i].name, bankCode: resData[i].code })
            }
            setBankList(bankData);
            setBankLabelList(bankLabels);

            bankData.findIndex((item) => {
                if (item.id == institutionId) {
                    setInstitutionId(institutionId);
                    setBankName(item.name);
                    setBankCode(item.code);
                    sessionStorage.setItem("bank_name", item.name);
                }
            })
        }

        getInstitutionList(history, institutionListCb);
    }, []);

    const handleStatementBankSelect1 = (index, selected) => {
        // let institution_id = e.target.value;
        setSelectedBankId(selected);
        let institution_id = selected.value;
        setInstitutionId(institution_id);
        if (institution_id != -1) {
            var statement = selectedStatements[index];
            statement.bank_details = selected;
        }
    }

    const handleStatementBankSelect = (index, e) => {
        let institution_id = e.target.value;
        setInstitutionId(institution_id);
        if (institution_id != -1) {
            var statement = selectedStatements[index];
            statement.institution_id = institution_id
            bankList.findIndex((item) => {
                if (item.id == institution_id) {
                    setBankName(item.name);
                    statement.bank_name = item.name;
                }
            })
            updateStatements(index, statement);
        }
    }

    const handleSingleFile = (index, file) => {
        setShowLoader(false);
        setIsSubmitError(false);
        if (file != null) {
            var statement = {};
            statement.file = file;
            statement.state = states.file_selected;
            statement.bank_details = { "value": institutionId, "label": bankName };
            if (file.type != "application/pdf") {
                statement.state = states.file_error;
                statement.err_msg = pdfSupportError;
            }
            else if (file.size > maxPdfSize) {
                statement.state = states.file_error;
                statement.err_msg = pdfSizeMaxError;
            }
            else if (file.size < minPdfSize) {
                statement.state = states.file_error;
                statement.err_msg = pdfSizeMinError;
            }
            else {
                
            }
            updateStatements(index, statement);
        }

    };

    const handleMultipleFiles = (files) => {
        setShowLoader(false);
        setIsSubmitError(false);
        if ((files != null) && (files.length > 0)) {
            var statementList = [];
            for (var i = 0; i < files.length; i++) {
                var file = files[i];
                if (file != null) {
                    var statement = {};
                    statement.file = file;
                    statement.state = states.file_selected;
                    statement.bank_details = { "value": institutionId, "label": bankName };
                    if (file.type != "application/pdf") {
                        statement.state = states.file_error;
                        statement.err_msg = pdfSupportError;
                    }
                    else if (file.size > maxPdfSize) {
                        statement.state = states.file_error;
                        statement.err_msg = pdfSizeMaxError;
                    }
                    else if (file.size < minPdfSize) {
                        statement.state = states.file_error;
                        statement.err_msg = pdfSizeMinError;
                    }
                    else {
                        
                    }
                    statementList.push(statement);
                }
            }
            setSelectedStatements(prevItems => [...prevItems, ...statementList]);
        }

    };

    const showChooseFileLoader = () => {
        setShowLoader(true);
    }

    const chooseFile = (id) => {

        if (showLoader) {
            return;
        }
        document.getElementById(id).click();
    }

    // Function to update an object in the array based on index
    const updateStatements = (index, newData) => {
        setSelectedStatements(prevItems =>
            prevItems.map((item, i) =>
                i === index ? { ...item, ...newData } : item
            )
        );
    };

    const removeStatement = (index) => {
        setSelectedStatements(prevItems => {
            const updatedItems = prevItems.filter((_, i) => i !== index);
            storeStatementList(updatedItems);
            return updatedItems;
        });
    }

    const deleteStatement = (fileIndex) => {
        setIsSubmitError(false);

        const deleteUiStmtCb = (res) => {
            if (res.data.status == "success") {
                // var statement = selectedStatements[fileIndex];
                // statement.state = states.stmt_deleted;
                // updateStatements(fileIndex, statement);

                removeStatement(fileIndex);

                let accInfo = {};
                if (!isNullOrEmpty(localStorage.getItem("account_info"))) {
                    accInfo = JSON.parse(localStorage.getItem("account_info"));
                }
                if (!isNullOrEmpty(res.data.bank_statement_info)) {
                    accInfo.bank_statement_info = res.data.bank_statement_info;
                }
                else {
                    accInfo.file_list = res.data.file_list;
                    accInfo.account_number = res.data.account_number;
                    accInfo.bank_name = res.data.bank_name;
                }
                localStorage.setItem("account_info", JSON.stringify(accInfo));
            }
            else {
                var statement = selectedStatements[fileIndex];
                statement.state = states.stmt_delete_error;
                statement.del_err_msg = res.data.msg;
                updateStatements(fileIndex, statement);
            }
        }

        if (![states.stmt_processed, states.stmt_error, states.stmt_password_required, states.stmt_password_error].includes(selectedStatements[fileIndex].state)) {

            var statement = selectedStatements[fileIndex];
            statement.state = states.file_deleted;
            updateStatements(fileIndex, statement);
            removeStatement(fileIndex);
        }
        else {
            var statement = selectedStatements[fileIndex];
            statement.state = states.stmt_delete_processing;
            updateStatements(fileIndex, statement);

            const data = {
                txn_id: txnId,
                sender: "frontend",
                stmt_id: selectedStatements[fileIndex].statement_id
            }

            deleteUiStmt(data, history, deleteUiStmtCb, { index: fileIndex });
        }
    };

    const handleSubmit = () => {
        setIsSubmitError(false);

        if (showLoader) {
            return;
        }

        if (selectedStatements.length === 0) {
            setIsSubmitError(true);
            setSubmitErrMsg(pdfChooseError);
            return;
        }

        
        const uploadUiStmtCb = (res) => {

            var statement = selectedStatements[res.extra_data.index];
            statement.statement_id = res.data.statement_id;

            localStorage.setItem("statement_id", res.data.statement_id);
            if (res.data.status == "success") {
                statement.state = states.stmt_processed;
                storeStatementList(selectedStatements);
                //localStorage.setItem("statement_list", JSON.stringify(selectedStatements));
                localStorage.setItem("account_info", JSON.stringify(res.data));
                //history.push("/pdflist");
            }
            else {
                if (res.data.code == statusCodeNoFilePassword) {
                    statement.state = states.stmt_password_required;
                    statement.input_type = "password";
                    //history.push('/pdfpassword');
                }
                else {
                    statement.state = states.stmt_error;
                    statement.err_msg = res.data.msg;
                }
            }
            updateStatements(res.extra_data.index, statement);
            processFile(res.extra_data.index + 1);
        }

        const uploadToFirebase = (fileIndex) => {

            var statement = selectedStatements[fileIndex];
            statement.state = states.firebase_upload_processing;
            statement.progress_percent = 0;
            updateStatements(fileIndex, statement);

            let firebaseUrl = `statements/${txnId}/${statement.file.name}`;

            const data = {
                txn_id: txnId,
                file_password_b16: '',
                file_firebase_url: firebaseUrl,
                execution_type: "file_submit",
                destination: destinationPdfUpload
            }
            if ((statement.bank_details?.value != "-1") && (bankSelectionEnabled == "1")) {
                data.institution_id = statement.bank_details?.value
            }

            let blob = new Blob([statement.file.file], { type: statement.file.type });  // Use the file's MIME type
            //var uploadTask = storageRef.ref("/" + firebaseUrl).putString(statement.file.base64, 'data_url')

            const storRef = ref(storageRef, `/${firebaseUrl}`);
            const uploadTask = uploadBytesResumable(storRef, blob);

            uploadTask.on("state_changed",
                (snapshot) => {
                    var progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                    statement.state = states.firebase_upload_processing;
                    statement.progress_percent = progress;
                    updateStatements(fileIndex, statement);
                }, (error) => {
                    statement.state = states.firebase_upload_error;
                    statement.err_msg = error.message;
                    updateStatements(fileIndex, statement);
                }, () => {
                    statement.state = states.stmt_submit_processing;
                    updateStatements(fileIndex, statement);
                    uploadUiStmt(data, history, uploadUiStmtCb, { index: fileIndex });
                }
            )
        }

        const processFile = (index) => {
            if (index == selectedStatements.length) {
                return;
            }
            if ((selectedStatements[index].state == states.file_selected)) {
                uploadToFirebase(index);
            }
            else {
                processFile(index + 1);
            }
        }

        processFile(0);
    }

    const sendPassword = (index) => {

        var statement = selectedStatements[index];

        const data = {
            txn_id: txnId,
            file_password_b16: btoa(statement.password),
            statement_id: statement.statement_id,
            execution_type: "password_submit",
            destination: destinationPdfUpload
        }
        if ((statement.bank_details?.value != "-1") && (bankSelectionEnabled == "1")) {
            data.institution_id = statement.bank_details?.value
        }

        const uploadUiStmtCb = (res) => {
            if (res.data.status == "success") {
                statement.state = states.stmt_processed;
                storeStatementList(selectedStatements);
                //localStorage.setItem("statement_list", JSON.stringify(selectedStatements));
                localStorage.setItem("account_info", JSON.stringify(res.data));
                //sessionStorage.setItem("uploaded_file_list", JSON.stringify(res.data.filenames));
                //history.push("/pdflist");
            }
            else {
                if (res.data.code == statusCodeInvalidPassword) {
                    statement.state = states.stmt_password_error;
                    statement.err_msg = res.data.msg;
                }
                else {
                    statement.state = states.stmt_error;
                    statement.err_msg = res.data.msg;
                }
            }

            updateStatements(index, statement);
        }

        uploadUiStmt(data, history, uploadUiStmtCb, { index: index });
    }

    const handlePasswordSubmit = (index) => {
        var statement = selectedStatements[index];
        if ((!isNullOrEmpty(statement.password))) {
            statement.state = states.stmt_password_processing;
            updateStatements(index, statement);
            sendPassword(index);
        }
        else {
            statement.state = states.stmt_password_error;
            statement.err_msg = "Enter Password";
            updateStatements(index, statement);
        }
    }

    const handleFinish = () => {
        var processedCount = 0;
        var processingCount = 0;
        var uploadingCount = 0;
        //var processedStatements = [];

        for (var i = 0; i < selectedStatements.length; i++) {
            if ((selectedStatements[i].state == states.firebase_upload_processing) || (selectedStatements[i].state == states.stmt_submit_processing)) {
                uploadingCount = uploadingCount + 1;
            }
            else if (selectedStatements[i].state == states.stmt_processed) {
                //processedStatements.push(selectedStatements[i]);
                processedCount = processedCount + 1;
            }
            else if ([states.firebase_upload_processing, states.stmt_submit_processing, states.stmt_password_processing, states.stmt_delete_processing].includes(selectedStatements[i].state)) {
                processingCount = processingCount + 1;
            }
        }

        if ((!isNullOrEmpty(maxAllowedFiles)) && processedCount > maxAllowedFiles) {
            setIsSubmitError(true);
            setSubmitErrMsg(maxAllowedFilesError + maxAllowedFiles);
            return;
        }

        //setProcessedStatements(processedStatements);

        if (processedCount == selectedStatements.length) {
            submitComplete();
        }
        else {
            if ((processingCount > 0) || (uploadingCount > 0)) {
                return;
            }
            else {
                if (processedCount == 0) {
                    setIsSubmitError(true);
                    setSubmitErrMsg(stmtSubmitNoFileError);
                }
                else {
                    setShowConfirmPopup(true);
                }
            }
        }
    }

    // Check if at least one item is selected
    const atLeastOneSelected = selectedStatements.some(item => (item.state == states.file_selected));

    // Check if at least one item is processed
    //const atLeastOneProcessed = selectedStatements.some(item => (item.state == states.stmt_processed));

    // Check if all items are not processing
    const allNotProcessing = selectedStatements.every(item => (![states.stmt_password_processing, states.stmt_delete_processing, states.stmt_submit_processing, states.firebase_upload_processing].includes(item.state)));

    const isSubmitBtnEnabled = atLeastOneSelected && allNotProcessing;

    const isFinishBtnEnabled = (isSubmitBtnEnabled != true) && (selectedStatements.length > 0) && allNotProcessing;

    const isDeleteIconEnabled = (item) => {
        if (![states.stmt_processed, states.stmt_error, states.stmt_password_required, states.stmt_password_error].includes(item.state)) {
            return true;
        }
        else{
            return allNotProcessing;
        }
    }

    const handleConfirmPopupYes = () => {
        handleConfirmPopupClose();
        submitComplete();
    }

    const submitComplete = () => {
        //if (!isSubmitted) {
        storeStatementList(selectedStatements);
        //localStorage.setItem("statement_list", JSON.stringify(selectedStatements));
        //setSubmitted(true);
        //statusCheck(history, submitCompleteCb);
        history.push("/pdflist");
        //}
    }

    const submitCompleteCb = (res) => {
        if (res.data.status == "success") {
            localStorage.setItem("account_info", JSON.stringify(res.data));
            history.push("/pdflist");
        }
        else {
            setIsSubmitError(true);
            setSubmitErrMsg(res.data.msg);
        }
        //setSubmitted(false);
    }

    const handleCancel = () => {
        setShowCancelPopup(true);
    }

    const handleCancelPopupClose = () => {
        setShowCancelPopup(false);
    }

    const handleConfirmPopupClose = () => {
        setShowConfirmPopup(false);
    }

    const handleCancelPopupYes = () => {
        handleCancelPopupClose();
        sessionStorage.setItem('status_code', statusCodeUserCancelled);
        sessionStorage.setItem('status', false);
        history.push("/txncomplete");
        //PDFUploadFinish(history, pdfUploadFinishCb);
    }

    const handleCancelPopupNo = () => {
        handleCancelPopupClose();
    }

    const handleConfirmPopupNo = () => {
        handleConfirmPopupClose();
    }

    const handleViewFiles = () => {
        submitComplete();
        // localStorage.setItem("statement_list", JSON.stringify(selectedStatements));
        // history.push("/pdflist");
    }

    const handlePasswordChange = (index, e) => {
        var value = e.target.value;
        var file = selectedStatements[index];
        file.password = value.substring(0, 45);
        if (value.length > 0) {
            file.eye_div_disp = dispContent;
        }
        else {
            file.eye_div_disp = hideContent;
        }
        updateStatements(index, file);
    }

    const handleEyeClick = (index) => {
        var stmt = selectedStatements[index];
        stmt.input_type = (stmt.input_type === 'text' ? 'password' : 'text');
        stmt.eye_on = (!stmt.eye_on);
        updateStatements(index, stmt);
    }

    const storeStatementList = (statements) => {
        const modifiedList = statements.map(item => {
            const { base64, file, ...fileWithoutBase64AndRaw } = item.file;  // Destructure to exclude base64 and file_raw
            return {
                ...item,
                file: fileWithoutBase64AndRaw
            };
        });
        localStorage.setItem('statement_list', JSON.stringify(modifiedList));
    }

    const CustomOption = (props) => {
        const { innerRef, innerProps, isFocused, isSelected } = props;

        useEffect(() => {
            if (isFocused && innerRef?.current) {
                innerRef.current.scrollIntoView({
                    block: 'nearest',
                    behavior: 'smooth',
                });
            }
        }, [isFocused, innerRef]);

        return (
            <div
                ref={innerRef}
                {...innerProps}
                className="custom-option"
                style={{
                    backgroundColor: isFocused ? '#f0f0f0' : 'white',
                    color: isSelected ? '#212121' : '#000',
                    cursor: 'pointer',
                }}
            >
                <img className="bank-logo" src={getBankLogo(props.data.bankCode)} />
                <span className="select-checkbox-label" style={fontMedium}>{props.data.label}</span>
            </div>
        );
    };


    const CustomControl = forwardRef(({ children, innerRef, innerProps, ...props }, ref) => {
        const handleControlClick = () => {
            // Find the input field within the 'custom-control' div
            //const inputField = document.getElementById('custom-control')?.querySelector('input');

            // Focus on the input field if found
            //inputField && inputField.focus();
        };

        const handleKeyPress = (event) => {
            const keyCode = event.keyCode || event.which;

            // Allow letters and some special characters like space (key codes: 65-90, 97-122, 32)
            if ((keyCode < 65 || keyCode > 90) && (keyCode < 97 || keyCode > 122) && keyCode !== 32) {
                event.preventDefault();
                console.log('Please enter only letters.');
            }
        };

        return (
            <div
                id='custom-control'
                className="custom-control"
                tabIndex={0}
                onClick={handleControlClick}
                onKeyPress={handleKeyPress}
                // Spread innerProps here to allow ReactSelect to handle the menu opening
                {...innerProps}
                style={{ display: 'flex', marginLeft: '-20px', height: '50px', alignItems: 'center', borderRadius: '5px', fontSize: '14px' }}
            >
                {/* <span>
                    <img src={getSearchIconPath()} style={{ width: '15px', height: 'auto' }} />
                </span> */}
                {children}
            </div>
        );
    });


    return (
        <div>
            <div className="normal-card">
                <div>
                    <div style={{ textAlign: 'left' }}>
                        <div className="card-action-title" style={fontBold}>Upload Bank PDF Statement</div>
                        <div className="card-msg" style={fontRegular}>Upload PDF statements{((((bankSelectionEnabled == "1") || (institutionIdGiven == "true")) && (multiAccountSupport == "0")) ? " of " + bankName : "")} from {startMonth} to {endMonth}</div>
                        {(!isNullOrEmpty(maxAllowedFiles) && maxAllowedFiles > 0) ? <div className="card-msg" style={fontMedium}>Bank Statement Upload Limit : {maxAllowedFiles}</div> : <></>}
                        <div style={{ marginTop: '20px' }}>
                            <div>
                                <div className="statements-div">
                                    {
                                        ((selectedStatements != undefined) && (selectedStatements.length > 0)) ?
                                            <div>
                                                {((showViewFiles == "true")) ?
                                                    <u><span className="view-files-text" style={textColorTheme} onClick={handleViewFiles}>Summary</span></u> : null}
                                                <h4 className="instructionTitle" style={fontMedium}>Upload</h4>
                                                <div style={{ clear: "both" }}></div>
                                                <div style={{ marginTop: '10px' }}>
                                                    <div>
                                                        <div>
                                                            {selectedStatements.map((item, index) => {
                                                                return (
                                                                    <div>
                                                                        <div style={{ width: '100%' }}>

                                                                            {((multiAccountSupport == "1") && (bankSelectionEnabled == "1")) ?
                                                                                <div style={{ display: 'inline-block', width: '38.5%', marginRight: '1%', marginLeft: '0.5%', verticalAlign: 'top' }}>
                                                                                    <div className="statement-file-div" style={{ padding: '0px', position: 'relative' }}>

                                                                                        {
                                                                                            ([states.firebase_upload_processing, states.stmt_submit_processing, states.stmt_processed, states.stmt_password_required, states.stmt_password_processing, states.stmt_password_error, states.stmt_error].includes(item.state)) ?
                                                                                                <div style={{ padding: '12px' }}>
                                                                                                    {/* <span><img className="bank-logo" src={getBankLogo(item?.bank_details?.bankCode)} /></span> */}
                                                                                                    <span className="statement-bank-select" style={fontRegular}>{item?.bank_details?.label}</span>
                                                                                                </div>
                                                                                                :
                                                                                                // <>
                                                                                                //     <select id={"bank-list" + index} className="statement-bank-select" value={item.institution_id} style={{ padding: '14px', paddingRight: '20px' }} name='setUserName' onChange={(e) => handleStatementBankSelect(index, e)} required>
                                                                                                //         <option value="-1">Select bank</option>
                                                                                                //         {bankList.map((item1) => {
                                                                                                //             return <option key={item1.id} value={item1.id}>
                                                                                                //                 {item1.name}
                                                                                                //             </option>
                                                                                                //         })}
                                                                                                //     </select>
                                                                                                //     <div className="float-right-icon" style={{ right: '5px', pointerEvents: 'none' }}>
                                                                                                //         <img src={getDropDownIconPath()} className="homeDropdownIcon" alt="dropdown" />
                                                                                                //     </div>
                                                                                                //     <div style={{ clear: 'both' }}>
                                                                                                //     </div>
                                                                                                // </>
                                                                                                <div>
                                                                                                    <ReactSelect
                                                                                                        id="fip_menu"
                                                                                                        className="custom-react-select"
                                                                                                        placeholder="select bank"
                                                                                                        options={bankLabelList}
                                                                                                        isMulti={false}
                                                                                                        closeMenuOnSelect={true}
                                                                                                        hideSelectedOptions={false}
                                                                                                        //isClearable
                                                                                                        components={{
                                                                                                            Option: (props) => {
                                                                                                                return <CustomOption {...props} />;  // Explicit return
                                                                                                            },
                                                                                                            Control: (props) => <CustomControl innerRef={props.innerRef} {...props} />
                                                                                                        }}
                                                                                                        onChange={(selectedOption) => handleStatementBankSelect1(index, selectedOption)}
                                                                                                        allowSelectAll={true}
                                                                                                        value={item.bank_details}
                                                                                                        styles={{
                                                                                                            indicatorSeparator: () => ({ display: 'none' }),
                                                                                                            dropdownIndicator: (provided) => ({
                                                                                                                ...provided,
                                                                                                                padding: '0', // Removes extra space around the arrow icon
                                                                                                                paddingRight: '5px'
                                                                                                            }),
                                                                                                            control: (provided) => ({
                                                                                                                ...provided,
                                                                                                                paddingRight: '0'
                                                                                                            }),
                                                                                                            valueContainer: (provided) => ({
                                                                                                                ...provided,
                                                                                                                padding: '0', // Reduces padding on the right side of the text
                                                                                                                paddingLeft: '5px'
                                                                                                            }),
                                                                                                            menuPortal: base => ({ ...base, zIndex: 99999999999 }),
                                                                                                            menu: base => ({
                                                                                                                ...base,
                                                                                                                zIndex: 99999999999
                                                                                                                //position: 'absolute', // Make the menu fixed
                                                                                                                //top: '25%', // Position below the select
                                                                                                            }),
                                                                                                        }}
                                                                                                        // menuIsOpen={menuIsOpen}
                                                                                                        // onMenuOpen={handleMenuOpen}
                                                                                                        // onMenuClose={handleMenuClose}
                                                                                                        maxMenuHeight={150}
                                                                                                    //menuPortalTarget={document.body} // Render dropdown outside parent container
                                                                                                    // menuPosition="fixed"             // Ensures positioning is correct
                                                                                                    // menuPlacement="auto"             // Allows flexible dropdown placement
                                                                                                    //ref={selectRef}
                                                                                                    />
                                                                                                </div>

                                                                                        }
                                                                                    </div>
                                                                                </div> : <></>}
                                                                            <div style={{ display: 'inline-block', width: ((multiAccountSupport == "1") && (bankSelectionEnabled == "1")) ? '58.5%' : '99%', marginLeft: ((multiAccountSupport == "1") && (bankSelectionEnabled == "1")) ? '1%' : '0.5%', marginRight: '0.5%' }}>
                                                                                <div className="statement-file-div" style={{ width: '100%' }}>
                                                                                    <div id="uploadBlock" style={{ display: "none" }}>
                                                                                        <FileBase64
                                                                                            id={"browseBtn" + index}
                                                                                            style={{ display: 'none' }}
                                                                                            multiple={false}
                                                                                            onSelect={showChooseFileLoader}
                                                                                            index={index}
                                                                                            onDone={handleSingleFile}
                                                                                        />
                                                                                    </div>
                                                                                    <div style={{ float: 'left' }} >
                                                                                        <img
                                                                                            src={getUploadIconPath()}
                                                                                            className="statement-upload-icon"
                                                                                            onClick={((item.state == states.file_selected)) ? () => chooseFile('browseBtn' + index) : null}
                                                                                            style={{ cursor: ((item.state != states.stmt_submit_processing) && (item.state != states.stmt_processed)) ? 'pointer' : 'default', pointerEvents: ((item.state != states.stmt_submit_processing) && (item.state != states.stmt_processed)) ? 'auto' : 'none' }}
                                                                                        />
                                                                                    </div>

                                                                                    <div style={{ float: 'right' }}>
                                                                                        {
                                                                                            (item.state == states.stmt_processed) ?
                                                                                                <img src={getFileSuccessIcon()} className="statement-status-icon" /> : <></>
                                                                                        }
                                                                                        {
                                                                                            ((item.state == states.stmt_password_required) || (item.state == states.stmt_password_processing) || (item.state == states.stmt_password_error)) ?

                                                                                                <Tooltip
                                                                                                    position="bottom"
                                                                                                    trigger="click"
                                                                                                    theme="light"
                                                                                                    arrow="true"
                                                                                                    arrowSize="small"
                                                                                                    html={(
                                                                                                        <div style={{ borderColor: '#FCA004' }}>
                                                                                                            <span style={{ color: '#FCA004' }}>{"Please enter password for this Bank statement"}</span>
                                                                                                        </div>
                                                                                                    )}
                                                                                                >
                                                                                                    <img src={getFileWarningIcon()} className="statement-status-icon" />
                                                                                                </Tooltip>
                                                                                                // <MessageTooltip text={"Please enter password for this Bank statement"} type={"warning"}>
                                                                                                //     <img src={getFileWarningIcon()} className="statement-status-icon" />
                                                                                                // </MessageTooltip> 
                                                                                                : <></>
                                                                                        }
                                                                                        {
                                                                                            ((item.state == states.stmt_error) || (item.state == states.file_error)) ?
                                                                                                <Tooltip
                                                                                                    position="bottom"
                                                                                                    trigger="click"
                                                                                                    theme="light"
                                                                                                    arrow="true"
                                                                                                    arrowSize="small"
                                                                                                    html={(
                                                                                                        <div style={{ borderColor: '#E41D1D' }}>
                                                                                                            <span style={{ color: '#E41D1D' }}>{item.err_msg}</span>
                                                                                                        </div>
                                                                                                    )}
                                                                                                >
                                                                                                    <img src={getFileErrorIcon()} className="statement-status-icon" />
                                                                                                </Tooltip>
                                                                                                // <MessageTooltip text={item.err_msg} type={"error"}>
                                                                                                //     <img src={getFileErrorIcon()} className="statement-status-icon" />
                                                                                                // </MessageTooltip>
                                                                                                : <></>
                                                                                        }
                                                                                        {
                                                                                            ((item.state == states.firebase_upload_processing) || (item.state == states.stmt_submit_processing) || (item.state == states.stmt_delete_processing) || (item.state == states.stmt_password_processing)) ?
                                                                                                <div style={{ display: 'inline-block', marginLeft: '10px', verticalAlign: 'middle' }}>
                                                                                                    <SmallLoader loaderStyle={loaderStyleCircle} />
                                                                                                </div> :
                                                                                                

                                                                                                <img src={getFileDeleteIcon()} style={{ marginLeft: '10px' }} className={(isDeleteIconEnabled(item)) ? "statement-status-icon" : "statement-status-icon disabled-btn-style"} onClick={() => deleteStatement(index)} />
                                                                                        }
                                                                                    </div>

                                                                                    <div style={{ verticalAlign: 'middle', marginLeft: '30px', marginRight: '70px' }}>
                                                                                        <span title={item.file.name} className="file-name-title" style={fontRegular}>{(item.state >= states.file_selected) ? item.file.name : "Upload Statement"}</span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        {
                                                                            (item.state == states.stmt_delete_error) ?
                                                                                <><p className="error-msg" style={errorMsgStyle}>{item.del_err_msg}</p></> : <></>
                                                                        }
                                                                        {
                                                                            ([states.stmt_password_required, states.stmt_password_processing, states.stmt_password_error].includes(item.state)) ?
                                                                                <div>
                                                                                    <div className="statement-file-div" style={{ paddingTop: '10px', marginLeft: '0.5%', marginRight: '0.5%' }}>
                                                                                        <div style={{ width: '100%' }}>
                                                                                            <div style={{ position: 'relative', width: '75%', display: 'inline-block', verticalAlign: 'middle' }}>
                                                                                                <input type={item.input_type} className="statement-password-input" autoComplete="off" autoCorrect="off" spellCheck="false" placeholder={inputHintPasswordUnlock} value={item.password} name='setPassword' onChange={(e) => handlePasswordChange(index, e)} required />
                                                                                                <div className="float-left-icon">
                                                                                                    {
                                                                                                        (item.eye_on) ?
                                                                                                            <FaEye onClick={() => handleEyeClick(index)}></FaEye> :
                                                                                                            <FaEyeSlash onClick={() => handleEyeClick(index)}></FaEyeSlash>
                                                                                                    }
                                                                                                </div>
                                                                                            </div>

                                                                                            <div style={{ display: 'inline-block', width: '25%', textAlign: 'right' }}>
                                                                                                {
                                                                                                    (item.state == states.stmt_password_processing) ?
                                                                                                        <SmallLoader loaderStyle={loaderStyleCircle} /> : <button className={(allNotProcessing) ? 'small-primary-button' : 'small-primary-button disabled-btn-style'} style={smallButtonTheme} onClick={() => handlePasswordSubmit(index)}>{btnSubmit}</button>
                                                                                                }
                                                                                            </div>
                                                                                        </div>

                                                                                    </div>
                                                                                    <div style={{ marginBottom: '5px' }}>
                                                                                        {
                                                                                            (item.state == states.stmt_password_error) ? <span className="error-msg" style={errorMsgStyle}>{item.err_msg}</span> : <></>
                                                                                        }
                                                                                    </div>
                                                                                </div> : <></>
                                                                        }

                                                                    </div>
                                                                )
                                                            })}
                                                        </div>
                                                        <div>
                                                            <div id="uploadBlock" style={{ display: "none" }}>
                                                                <InputFile
                                                                    id="browseMore"
                                                                    style={{ display: 'none' }}
                                                                    multiple={(multiSelectionEnabled == "1")}
                                                                    accept={(compressedSelectionEnabled == "1") ? "application/pdf,application/zip,application/x-zip-compressed" : "application/pdf"}
                                                                    onSelect={showChooseFileLoader}
                                                                    onDone={handleMultipleFiles.bind(this)}
                                                                />
                                                            </div>
                                                            <img src={getUploadMoreIcon()} style={{ verticalAlign: "middle" }} className="upload-more-icon" onClick={() => chooseFile('browseMore')} />
                                                            <span className="upload-more-text" style={fontRegular}>Upload more PDF</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> :
                                            <div style={{ textAlign: 'center' }}>
                                                <br />
                                                <br />
                                                <br />
                                                <div id="uploadBlock" style={{ display: "none" }}>
                                                    <InputFile
                                                        id="browseBtn"
                                                        style={{ display: 'none' }}
                                                        multiple={(multiSelectionEnabled == "1")}
                                                        accept={(compressedSelectionEnabled == "1") ? "application/pdf,application/zip,application/x-zip-compressed" : "application/pdf"}
                                                        onSelect={showChooseFileLoader}
                                                        onDone={handleMultipleFiles.bind(this)}
                                                    />
                                                </div>
                                                <div onClick={() => chooseFile('browseBtn')}>
                                                    <img src={getUploadFileIconPath()} style={{ cursor: 'pointer' }} className="respImgStyle" /><br />
                                                    <span style={fontRegular} className="card-msg">Click here to upload</span>
                                                </div>
                                            </div>
                                    }
                                </div>
                            </div>
                            {
                                (isSubmitError == true) ? <span className="error-msg" style={errorMsgStyle}>{submitErrMsg}</span> : null
                            }
                            <br />
                            <br />
                            <br />
                            <div className='bottomDiv' style={{ marginTop: '50px' }}>
                                <button className={(isFinishBtnEnabled == true) ? 'full-primary-button' : 'full-primary-button disabled-btn-style'} style={{ ...primaryButtonTheme, marginRight: '4%' }} onClick={handleFinish}>{btnFinish}</button>
                                <button className={(isSubmitBtnEnabled == true) ? 'full-primary-button' : 'full-primary-button disabled-btn-style'} style={primaryButtonTheme} onClick={handleSubmit}>{btnSubmit}</button>
                            </div>
                        </div>
                    </div>

                    {
                        (showCancelPopup == true) ?
                            <PopUp
                                close={handleCancelPopupClose}
                                onPrimaryBtnClick={handleCancelPopupYes}
                                onSecondaryBtnClick={handleCancelPopupNo}
                                primaryBtnText={btnYes}
                                secondaryBtnText={btnNo}
                                titleText={"Are you sure want to cancel ?"}
                                bodyText={stmtCancelError} /> : null}

                    {
                        (showConfirmPopup == true) ?
                            <PopUp
                                close={handleConfirmPopupClose}
                                onPrimaryBtnClick={handleConfirmPopupYes}
                                onSecondaryBtnClick={handleConfirmPopupNo}
                                primaryBtnText={btnYes}
                                secondaryBtnText={btnNo}
                                titleText={"Are you sure want to submit ?"}
                                bodyText={stmtSubmitError} /> : null}
                </div>
            </div>
        </div>
    );
};

export default withRouter(PdfUpload);